// extracted by mini-css-extract-plugin
module.exports = {"menu_wrapper":"Menu_menu_wrapper__g47lp","menu":"Menu_menu__5fwyu","menu_link":"Menu_menu_link__EMrzw","menu_filter":"Menu_menu_filter__70WXr","active":"Menu_active__UKkZ4"};